import React from "react";
import * as S from "./styles";

const CloseIcon = () => (
    <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1L8 8M8 1L1 8" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    </svg>
);

// Resumo dos filtros aplicados (uma "pilula" por valor selecionado, com um
// "x" pra remover só aquele valor) + um link "LIMPAR FILTROS" pra zerar
// tudo de uma vez. Não sabe nada sobre de onde vêm os filtros - quem usa
// monta a lista de `items` (um por chip) já com o `onRemove` de cada um.
const FilterCell = ({ items = [], onClearAll, clearAllLabel = "LIMPAR FILTROS" }) => {
    if (!items || items.length === 0) return null;

    return (
        <S.Container>
            {items.map((item) => (
                <S.Chip key={item.id}>
                    <S.ChipLabel>{item.label}</S.ChipLabel>
                    <S.ChipRemove
                        type="button"
                        aria-label={`Remover filtro ${item.label}`}
                        onClick={item.onRemove}
                    >
                        <CloseIcon />
                    </S.ChipRemove>
                </S.Chip>
            ))}

            {onClearAll && (
                <S.ClearAll type="button" onClick={onClearAll}>
                    {clearAllLabel}
                </S.ClearAll>
            )}
        </S.Container>
    );
};

export default FilterCell;
